import { FC } from 'react'
import Image from 'next/image'
import { Tables } from '@/supabase/types'
import { ChatFile, MessageImage } from '@/types'
import { IconFileFilled } from '@tabler/icons-react'

import { getReadableFileItemContent } from '@/lib/files/file-item-content'
import { cn } from '@/lib/utils'
import { BlurFade } from '@/components/ui/blur-fade'

import { DrawingCanvas } from '../utility/drawing-canvas'
import { Dialog, DialogContent } from './dialog'

interface FilePreviewProps {
  type: 'image' | 'file' | 'file_item'
  item: ChatFile | MessageImage | Tables<'file_items'>
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  chatId?: string
}

export const FilePreview: FC<FilePreviewProps> = ({
  type,
  item,
  isOpen,
  onOpenChange,
  chatId
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        className={cn(
          'flex items-center justify-center outline-none',
          'h-[90hw] w-[90vw] border-transparent bg-transparent'
        )}
      >
        {(() => {
          if (type === 'image') {
            const imageItem = item as MessageImage

            return imageItem.file ? (
              <DrawingCanvas imageItem={imageItem} chatId={chatId} />
            ) : (
              <BlurFade yOffset={0} key={imageItem.base64 || imageItem.url} delay={1} inView>
                <Image
                  className="animate-blur rounded-lg"
                  src={imageItem.base64 || imageItem.url}
                  alt="File image"
                  width={2000}
                  height={2000}
                  style={{
                    maxHeight: '85vh',
                    maxWidth: '85vw'
                  }}
                />
              </BlurFade>
            )
          } else if (type === 'file_item') {
            const fileItem = item as Tables<'file_items'>
            return (
              <div className="bg-background text-primary h-[50vh] min-w-[700px] overflow-auto whitespace-pre-wrap rounded-xl p-4">
                <div>{getReadableFileItemContent(fileItem.content)}</div>
              </div>
            )
          } else if (type === 'file') {
            return (
              <div className="rounded bg-violet-500 p-2">
                <IconFileFilled stroke={1.5} />
              </div>
            )
          }
        })()}
      </DialogContent>
    </Dialog>
  )
}
